/**
 * MuteButton Component - Button for toggling row mute state
 * Displays volume icon when unmuted, volume-slash when muted
 */

/**
 * Props for MuteButton component
 */
interface MuteButtonProps {
  /** Whether the row is muted */
  muted: boolean;
  /** Callback when mute is toggled */
  onToggle: () => void;
  /** Row index for accessibility */
  row: number;
}

/**
 * MuteButton component
 * Renders a button with Font Awesome icons for mute/unmute
 * 
 * @param props - Component props
 * @returns MuteButton component
 */
export function MuteButton({ muted, onToggle, row }: MuteButtonProps) {
  /**
   * Handle button click
   */
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onToggle();
  };

  /**
   * Build CSS classes
   */
  const buttonClasses = ['mute-btn', muted && 'muted'].filter(Boolean).join(' ');

  return (
    <button
      className={buttonClasses}
      onClick={handleClick}
      aria-label={`${muted ? 'Unmute' : 'Mute'} row ${row + 1}`}
      aria-pressed={muted}
      type="button"
      title={`${muted ? 'Unmute' : 'Mute'} this row`}
    >
      <span className="sr-only">{muted ? 'Unmute' : 'Mute'} row {row + 1}</span>
      {/* Font Awesome icons are rendered via CSS ::before pseudo-element */}
    </button>
  );
}
